import * as Yup from "yup";

export const paymentFormvalidationSchema = Yup.object().shape({
  fullName: Yup.string().required("Full name is required"),
  cardNumber: Yup.string().required("Card number is required"),
  cvc: Yup.string().required("CVC is required"),
  expirationDate: Yup.string()
    .required("Expiration date is required")
    .test("expirationDate", "Invalid expiration MM/YY format", (value) => {
      if (!value) return false;

      const [month, year] = value.split("/");
      if (!month || !year) return false;

      const currentDate = new Date();
      const currentYear = currentDate.getFullYear() % 100;
      const currentMonth = currentDate.getMonth() + 1;

      const expMonth = parseInt(month, 10);
      const expYear = parseInt(year, 10);

      const isMonthValid = expMonth >= 1 && expMonth <= 12;
      const isYearValid =
        expYear > currentYear ||
        (expYear === currentYear && expMonth >= currentMonth);

      return isMonthValid && isYearValid;
    }),

  shippingAddressData: Yup.lazy((_, context) => {
    return Yup.object().shape({
      line1: Yup.string().optional(),
      city: Yup.string().optional(),
      state: Yup.string().optional(),
      country: Yup.string().optional(),
      postalCode:
        context?.parent?.isSameAsBilling === false
          ? Yup.string().optional()
          : Yup.string().required("Shipping postal code is required"),
    });
  }),

  billingAddressData: Yup.object().shape({
    line1: Yup.string().required("Billing street address is required"),
    city: Yup.string().required("Billing city is required"),
    state: Yup.string().required("Billing state is required"),
    country: Yup.string().optional(),
    postalCode: Yup.string().required("Billing postal code is required"),
  }),
});
